import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type IndicatorOutWithId = {
  idIndicatorOut: number;
};

// Базовый тип для create/update операций выходов индикаторов
type IndicatorOutCreateUpdateData = IndicatorOutWithId & {
  idIndicator: number;
  name: string;
  index: number;
};

// Типы для WebSocket сообщений компонента indicatorOuts
type IndicatorOutsListMessage = WebSocketMessageWithFields<'indicator-out-list' | 'pair', {
  indicatorOuts: unknown[];
}>;
type IndicatorOutListNotFoundMessage = WebSocketMessageEmpty<'indicator-out-list-not-found'>;
type IndicatorOutCreateMessage = WebSocketMessageWithFields<'indicator-out-create' | 'indicator-out-create-success', IndicatorOutCreateUpdateData>;
type IndicatorOutUpdateMessage = WebSocketMessageWithFields<'indicator-out-update' | 'indicator-out-update-success', IndicatorOutCreateUpdateData>;
type IndicatorOutDeleteMessage = WebSocketMessageWithFields<'indicator-out-delete' | 'indicator-out-delete-success', IndicatorOutWithId>;

// Объединенный тип для всех сообщений
type IndicatorOutsWebSocketMessage = 
  | IndicatorOutsListMessage 
  | IndicatorOutListNotFoundMessage 
  | IndicatorOutCreateMessage 
  | IndicatorOutUpdateMessage 
  | IndicatorOutDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataIndicatorOuts',
},
  __name: 'indicatorOuts',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID выхода индикатора
const handleWebSocketMessage = (data: IndicatorOutsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-out-list':
    case 'pair':
      store.dispatch('indicatorOuts/wsSetIndicatorOuts', { indicatorOuts: data.indicatorOuts });
      break;
    case 'indicator-out-list-not-found':
      store.dispatch('indicator/wsSetEmptyIndicator');
      break;
    case 'indicator-out-create':
    case 'indicator-out-create-success':
      store.dispatch('indicatorOuts/wsIndicatorOutCreate', {
        idIndicatorOut: data.idIndicatorOut,
        idIndicator: data.idIndicator,
        name: data.name,
        index: data.index,
      });
      break;
    case 'indicator-out-update':
    case 'indicator-out-update-success':
      store.dispatch('indicatorOuts/wsIndicatorOutUpdate', {
        idIndicatorOut: data.idIndicatorOut,
        idIndicator: data.idIndicator,
        name: data.name,
        index: data.index,
      });
      break;
    case 'indicator-out-delete':
    case 'indicator-out-delete-success':
      store.dispatch('indicatorOuts/wsIndicatorOutDelete', {
        idIndicatorOut: data.idIndicatorOut,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})